module.exports = __webpack_public_path__ + "img/panelView_baoSteel_2_1.1fc2786d.png";